import { useDispatch, useSelector } from "react-redux";
import {
  addStaffNotification,
  deleteStaffNotification,
  getAllStaffNotification,
  getStaffNotification,
  markAsRead,
  readStaffNotification,
  resetActiveId,
  setOffset,
  setPage,
  setPerPage,
} from "../store/notification";

export function useNotification() {
  const dispatch = useDispatch();

  const notificationData = useSelector((state) => state.notification.data);
  const loading = useSelector((state) => state.notification.loading);
  const activeId = useSelector((state) => state.notification.activeId);
  const idFaculty = useSelector((state) => state.auth.userId);

  const page = useSelector((state) => state.notification?.page);
  const perPage = useSelector((state) => state.notification?.perPage);
  const offset = useSelector((state) => state.notification?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));
  const getAllStaffNotificationAction = (params) =>
    dispatch(getAllStaffNotification(params));

  const addStaffNotificationAction = (params) => {
    dispatch(addStaffNotification(params));
  };

  const readStaffNotificationAction = (params) => {
    dispatch(readStaffNotification(params));
  };

  const deleteStaffNotificationAction = (params) => {
    dispatch(deleteStaffNotification(params));
  };

  const getStaffNotificationAction = (params) => {
    dispatch(getStaffNotification(params));
  };

  const resetActiveIdAction = () => {
    dispatch(resetActiveId());
  };

  return {
    notificationData,
    loading,
    activeId,
    idFaculty,
    page,
    perPage,
    offset,

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,
    getAllStaffNotificationAction,
    addStaffNotificationAction,
    readStaffNotificationAction,
    deleteStaffNotificationAction,
    getStaffNotificationAction,
    resetActiveIdAction,
  };
}
